module.exports = __webpack_public_path__ + "static/media/march2025-1.3f162501.webp";